export const MODULE = "new/company-session";
